export type ConfigurationStepId =
  | 'district-information'
  | 'academics'
  | 'grading'
  | 'eoaa-info-1'
  | 'eoaa-info-2'
  | 'school-info'
  | 'review-and-submit';

export type ConfigurationStepStatus = 'completed' | 'in-progress' | 'not-started';

export interface ConfigurationStep {
  id: ConfigurationStepId;
  trackerLabel: string;
  cardTitles: string[];
}

const CONFIGURATION_STEPS: ConfigurationStep[] = [
  {
    id: 'district-information',
    trackerLabel: 'District information',
    cardTitles: ['District information', 'Student data', 'Data Sharing Agreement'],
  },
  {
    id: 'academics',
    trackerLabel: 'Academics',
    cardTitles: ['Academic periods', 'Aliases', 'Additional information'],
  },
  {
    id: 'grading',
    trackerLabel: 'Grading',
    cardTitles: ['Grading'],
  },
  {
    id: 'eoaa-info-1',
    trackerLabel: 'EOAA info 1',
    cardTitles: ['EOAA information: General', 'EOAA information: Survey'],
  },
  {
    id: 'eoaa-info-2',
    trackerLabel: 'EOAA info 2',
    cardTitles: ['EOAA information: Colleges', 'EOAA information: college eligibility'],
  },
  {
    id: 'school-info',
    trackerLabel: 'School info',
    cardTitles: ['Add schools'],
  },
  {
    id: 'review-and-submit',
    trackerLabel: 'Review and submit',
    cardTitles: ['District information', 'Academics', 'Grading', 'EOAA information', 'Schools'],
  },
];

const getConfigurationStepIndex = (stepId: string | undefined): number =>
  CONFIGURATION_STEPS.findIndex((step) => step.id === stepId);

const getConfigurationStep = (stepId: string | undefined): ConfigurationStep | undefined =>
  CONFIGURATION_STEPS.find((step) => step.id === stepId);

const getConfigurationStepStatus = (stepIndex: number, currentIndex: number): ConfigurationStepStatus => {
  if (stepIndex < currentIndex) return 'completed';
  if (stepIndex === currentIndex) return 'in-progress';
  return 'not-started';
};

export { CONFIGURATION_STEPS, getConfigurationStep, getConfigurationStepIndex, getConfigurationStepStatus };
